export default __webpack_public_path__ + "static/media/search.ab27167c.svg";